export const WS_STATUS = {
  INIT: 'INIT',
  OPENING: 'OPENING',
  OPEN: 'OPEN',
  CLOSING: 'CLOSING',
  CLOSED: 'CLOSED',
  OPEN_ERROR: 'OPEN_ERROR',
  OPEN_TIMEOUT: 'OPEN_TIMEOUT',
  HEARTBEAT_TIMEOUT: 'HEARTBEAT_TIMEOUT',
  ERROR: 'ERROR',
};
